/** Prefix for sales bill numbers (must match InsertSales / computeNextSalesInvoiceNumber). */
export const SALES_ESTIMATE_INVOICE_TYPE = "SALES ESTIMATE";

export function isSalesEstimateInvoiceType(invoiceType: string): boolean {
  return invoiceType === SALES_ESTIMATE_INVOICE_TYPE;
}

export function salesInvoicePrefix(invoiceType: string): string {
  return `TAP${invoiceType === "SALES TAX INVOICE" ? "TI" : "ES"}`;
}

const ESTIMATE_BILL_STORAGE_PREFIX = "pos_sales_estimate_bill_no";

export function getLocalEstimateBillNo(
  financeYear: string,
  fallback: string,
): string {
  if (!financeYear) return fallback;
  try {
    const stored = localStorage.getItem(
      `${ESTIMATE_BILL_STORAGE_PREFIX}_${financeYear}`,
    );
    if (stored && /^(TAPES)\d{5}$/.test(stored.trim())) {
      return stored.trim();
    }
  } catch {
    /* ignore storage errors */
  }
  return fallback;
}

export function saveLocalEstimateBillNo(
  financeYear: string,
  billNo: string,
): void {
  if (!financeYear || !/^(TAPES)\d{5}$/.test(billNo.trim())) return;
  try {
    localStorage.setItem(
      `${ESTIMATE_BILL_STORAGE_PREFIX}_${financeYear}`,
      billNo.trim(),
    );
  } catch {
    /* ignore storage errors */
  }
}

/** Increment TAPTI02501 → TAPTI02502; returns null if format invalid. */
export function incrementSalesInvoiceNumber(current: string): string | null {
  const trimmed = (current || "").trim();
  const match = trimmed.match(/^(TAP(?:TI|ES))(\d{5})$/);
  if (!match) return null;
  const next = parseInt(match[2], 10) + 1;
  return `${match[1]}${String(next).padStart(5, "0")}`;
}
